<template>
  <v-app baseline>
    <v-toolbar color="primary" class="pageHeader">
      <v-toolbar-side-icon @click.stop="drawer = !drawer" dark></v-toolbar-side-icon>
      <v-toolbar-title><a href="/">Vermont Roads</a></v-toolbar-title>
      <v-toolbar-items>
        <v-btn flat dark><a href="/map">State Map</a></v-btn>
        <v-btn flat dark><a href="/towns">Towns</a></v-btn>
        <v-btn flat dark><a href="/mymap">My Map</a></v-btn>
        <v-btn flat dark><a href="/donate">Donate</a></v-btn>
        <v-btn flat dark><a href="/contact">Contact</a></v-btn>
        <v-btn flat dark><a href="https://nhroads.com">New Hampshire Roads</a></v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
  <v-navigation-drawer
      temporary
      v-model="drawer"
      light
      absolute
    >
      <v-toolbar flat class="transparent">
      <v-list class="pa-0">
        <v-list-tile avatar>
          <v-list-tile-content>
            <v-list-tile-title>Vermont Roads</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-list class="pt-0" dense>
      <v-divider>aaa</v-divider>
      <v-list-tile>
        <v-list-tile-action>
          <v-btn flat dark><a href="/map">Map</a></v-btn>
          <v-btn flat dark><a href="/towns">Towns</a></v-btn>
          <v-btn flat dark><a href="/mymap">My Map</a></v-btn>
          <v-btn flat dark><a href="/donate">Donate</a></v-btn>
          <v-btn flat dark><a href="/contact">Contact</a></v-btn>
          <v-btn flat dark><a href="https://nhroads.com">New Hampshire Roads</a></v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    </v-navigation-drawer>
    <v-footer
      height="auto"
      color="primary"
    >
    <v-layout
      justify-center
      row
      wrap
    >
      <v-btn
        v-for="link in links"
        :key="link"
        :href="'https://vermontroads.net/'+ link"
        color="white"
        flat
        round
      >
        {{link}}
      </v-btn>
      <a class="v-btn v-btn--flat v-btn--round theme--light white--text" href="https://nhroads.com">New Hampshire Roads</a>
      <v-flex
        primary
        py-3
        text-xs-center
        white--text
        xs12
      >
        Copyright &copy; {{ new Date().getFullYear() }} — <strong>Vermont Roads</strong>
      </v-flex>
    </v-layout>
  </v-footer>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
        drawer: false,
        links: [
          'map',
          'towns',
          'mymap',
          'donate',
          'contact'
        ]
      }
    }
  }
</script>